<template>
    <div id="navBox" @mouseleave="outNavEvent">
        <div class="navTag">
            <!-- <div class="logo" @click="$router.push({path:'/'})"><img src="../assets/logo.png" height="20" width="177"/>
            </div> -->
            <div>羽拾</div>
            <ul class="navList">
                <li @mouseenter="otherEvent" @click="toPage('/',0)">
                    <span class="line" v-show="navIndex===0"></span>
                    首页
                </li>
                <li @mouseenter="otherEvent" @click="toPage('/coreCompetence',1)">
                    <span class="line" v-show="navIndex===1"></span>
                    核心能力
                </li>
                <li @mouseenter="otherEvent" @click="toPage('/yxCenter',6)">
                    <span class="line" v-show="navIndex===6"></span>
                    营销服务中心
                </li>
                <li @mouseenter="ProductEvent">
                    <span class="line" v-show="navIndex===5"></span>
                    产品中心
                </li>
                <li @mouseenter="otherEvent" @click="toPage('/cooperationCase',2)">
                    <span class="line" v-show="navIndex===2"></span>
                    合作案例
                </li>
                <!--<li @mouseenter="otherEvent" @click="toPage('/apiDocument',3)">
                    <span class="line" v-show="navIndex===3"></span>
                    帮助与支持
                </li>-->
                <li @mouseenter="otherEvent" @click="toPage('/aboutAndJoinUs',4)">
                    <span class="line" v-show="navIndex===4"></span>
                    关于我们
                </li>
            </ul>
            <!--<a href="#" class="loginBox">登陆注册</a>-->
        </div>
        <!--定位导航-->
        <div class="productCenterBox" v-show="showProductCenter">
            <div class="leftImgWrap">
                <img src="../assets/img/nav/大背景.png" class="leftImg" v-if="!leftImgChangeFlag"/>
                <img src="../assets/img/nav/背景.png" class="leftImg" v-if="leftImgChangeFlag"/>
                <!--文字-->
                <div class="con">
                    <div>大数据产品中心</div>
                    <span>PRODUCT CENTER</span>
                </div>
            </div>
            <!--产品-->
            <div class="productListWrap">
                <div class="productListBox">
                    <div class="productTitle">智能通用服务产品</div>
                    <div class="productList" @click="toPage('/toolSubscription')">
                        <img src="../assets/img/nav/个性化工具订阅.png"/>
                        <div class="rightVal">
                            <p>个性化工具订阅</p>
                            <span>开发者便捷小工具与合作伙伴更好更快更便捷地对接工作</span>
                        </div>
                    </div>
                    <div class="productList" @click="toPage('/riskWarningReport')">
                        <img src="../assets/img/nav/风控.png"/>
                        <div class="rightVal">
                            <p>风险预警报告</p>
                            <span>对企业业务的风险因素进行预警输出报告</span>
                        </div>
                    </div>
                    <div class="productList" @click="toPage('/modelFactory')">
                        <img src="../assets/img/nav/模型工厂.png"/>
                        <div class="rightVal">
                            <p>模型工厂</p>
                            <span>利用机器学习技术对数据建立数学模型</span>
                        </div>
                    </div>
                    <div class="productList" @click="toPage('/factorServices')">
                        <img src="../assets/img/nav/因子服务.png"/>
                        <div class="rightVal">
                            <p>因子服务</p>
                            <span>对多维度的信息标签降维分析</span>
                        </div>
                    </div>
                    <div class="productList" @click="toPage('/smartLabel')">
                        <img src="../assets/img/nav/智能标签.png"/>
                        <div class="rightVal">
                            <p>智能标签</p>
                            <span>通过大数据技术加密聚类得到标签</span>
                        </div>
                    </div>
                    <!--@click="toPage('/InformationCheck')"-->
                    <div class="productList notClick">
                        <img src="../assets/img/nav/信息核验.png"/>
                        <div class="rightVal">
                            <p>信息核验</p>
                            <span>暂未上线...</span>
                            <!--<span>三要素实名认证，通过加密的手机号、姓名、身份证号来校验三者是否一致</span>-->
                        </div>
                    </div>
                    <!--@click="toPage('/faceRecognition')"-->
                    <div class="productList notClick">
                        <img src="../assets/img/nav/人脸识别.png"/>
                        <div class="rightVal">
                            <p>人脸识别</p>
                            <span>暂未上线...</span>
                            <!--<span>人脸检测与属性分析，人脸1：1对比、人脸监测校验能力服务</span>-->
                        </div>
                    </div>
                    <!--@click="toPage('/RiskListFiltering')"-->
                    <div class="productList notClick">
                        <img src="../assets/img/nav/风险名单过滤.png"/>
                        <div class="rightVal">
                            <p>风险名单过滤</p>
                            <!--<span>过滤业务的风险数据让企业间的合作更健康</span>-->
                            <span>暂未上线...</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="productListWrap">
                <div class="productListBox" style="margin-right: 75px">
                    <div class="productTitle">智能决策产品</div>
                    <div class="productList" @click="toPage('/znyxSystem')">
                        <img src="../assets/img/nav/智能营销系统.png"/>
                        <div class="rightVal">
                            <p>智能营销系统</p>
                            <span>帮助金融企业构建优质的营销生态，从广告、转化、活跃、留存、到流失等用户生命周期数据进行全面分析并优化，实现精细化的运营效果，从而达到精准营销的目的</span>
                        </div>
                    </div>
                    <div class="productList" @click="toPage('/znkqdcSystem')">
                        <img src="../assets/img/nav/智能客群洞察系统.png"/>
                        <div class="rightVal">
                            <p>智能客群洞察系统</p>
                            <span>帮助企业深度理解用户群特征，协助企业洞察目标客户的人群特征和线上、线下行为轨迹，有针对性地制定营销、运营策略</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="productListWrap">
                <div class="productListBox">
                    <div class="productTitle">定制产品</div>
                    <!--@click="toPage('/autobiography')"-->
                    <div class="productList notClick">
                        <img src="../assets/img/nav/个性化定制.png"/>
                        <div class="rightVal">
                            <p>个性化定制</p>
                            <!--<span>灵活合作，对客户特殊需求、协作程度非常高的业务进行个性化需求定制</span>-->
                            <span>暂未上线...</span>
                        </div>
                    </div>
                    <!--@click="toPage('/optimizeEnterprise')"-->
                    <div class="productList notClick">
                        <img src="../assets/img/nav/企业优化方案定制.png"/>
                        <div class="rightVal">
                            <p>企业资源与效率优化</p>
                            <!--<span>针对企业现有资源进行全方位的分析与最优化配置，让企业更高效、稳健地发展</span>-->
                            <span>暂未上线...</span>
                        </div>
                    </div>
                    <!--@click="toPage('/bigDataOperating')"-->
                    <div class="productList notClick">
                        <img src="../assets/img/nav/大数据操作系统.png"/>
                        <div class="rightVal">
                            <p>大数据操作系统设计</p>
                            <!--<span>企业间深度合作业务，针对企业全方位需求设计顶层设计系统</span>-->
                            <span>暂未上线...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "navTag",
        data() {
            return {
                styleObject: {
                    left: ""
                },
                showProductCenter: false,
                navIndex: 0,
                leftImgChangeFlag: false
            }
        },
        created() {
            this.changeActiveIndex();
            /*监听窗口大小变化*/
            window.addEventListener('resize', this.resizeEvent);
        },
        watch: {
            /*监听路由变化*/
            $route() {
                this.changeActiveIndex();
            }
        },
        methods: {
            otherEvent() {
                this.showProductCenter = false;
            },
            ProductEvent() {
                this.showProductCenter = true;
            },
            outNavEvent() {
                this.showProductCenter = false;
            },
            toPage(page, index) {
                this.showProductCenter = false;
                if (index) {
                    this.navIndex = index;
                } else {
                    this.navIndex = 5;
                }
                this.$router.push({path: page})
            },
            /*判断当前路由，回显导航*/
            changeActiveIndex() {
                let path = this.$route.path;
                if (path === "/") {
                    this.navIndex = 0;
                } else if (path === "/coreCompetence") {
                    this.navIndex = 1;
                } else if (path === "/cooperationCase") {
                    this.navIndex = 2;
                } else if (path === "/apiDocument"
                    || path === "/FAQ") {
                    this.navIndex = 3;
                } else if (path === "/aboutAndJoinUs"
                    || path === "/aboutUs"
                    || path === "/joinUs") {
                    this.navIndex = 4;
                } else if (path === "/yxCenter") {
                    this.navIndex = 6;
                } else {
                    this.navIndex = 5;
                }
            },
            /*监听窗口大小变化*/
            resizeEvent() {
                if (window.innerWidth <= 1500) {
                    this.leftImgChangeFlag = true;
                    return
                }
                this.leftImgChangeFlag = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #navBox {
        position: relative;
        width: 100%;
        border-bottom: 1px solid rgba(21, 49, 117, 0.19);

        .navTag {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 1200px;
            margin: 0 auto;
            padding: 26px 0;

            .logo {
                font-size: 20px;
                color: #030C22;
                text-align: justify;
                cursor: pointer;
            }

            .navList {
                position: relative;
                display: flex;
                align-items: center;
                padding-left: 12px;

                li {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 60px;
                    font-size: 16px;
                    color: #030C22;
                    text-align: justify;
                    cursor: pointer;

                    &:last-child {
                        margin-right: 0;
                    }
                }

                .line {
                    position: absolute;
                    display: inline-block;
                    bottom: -4px;
                    /*left: 6px;*/
                    width: 20px;
                    height: 2px;
                    background: #000FED;
                    border-radius: 3px;
                    font-size: 0;
                    transition: all 0.2s;
                }
            }

            .loginBox {
                font-size: 16px;
                color: #152346;
                opacity: 0.6;
                text-align: justify;
            }
        }

        .productCenterBox {
            position: absolute;
            display: flex;
            left: 0;
            top: 79px;
            width: 100%;
            min-width: 1200px;
            background: #fff;
            z-index: 1000;
            box-shadow: rgba(0, 0, 0, 0.12) 0 14px 14px -14px;

            .productListWrap {
                padding-top: 30px;
            }

            .productListBox {
                min-width: 228px;
                margin-right: 116px;

                .productTitle {
                    margin-bottom: 30px;
                    font-size: 18px;
                    font-weight: bold;
                    color: #152346;
                }

                .productList {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-bottom: 20px;

                    img {
                        width: 30px;
                        height: 30px;
                        margin-right: 8px;
                    }

                    .rightVal {
                        p {
                            margin-bottom: 4px;
                            font-size: 18px;
                            color: #152346;
                            text-align: left;
                        }

                        span {
                            display: block;
                            width: 180px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            opacity: 0.5;
                            font-size: 12px;
                            color: #152346;
                        }
                    }
                }

                .notClick {
                    opacity: 0.3;
                    cursor: not-allowed;
                }
            }
        }

        .leftImgWrap {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 542px;
            margin-right: 80px;

            .leftImg {
                height: 100%;
            }

            .con {
                position: absolute;
                top: 362px;
                text-align: center;

                div {
                    opacity: 0.76;
                    font-size: 20px;
                    color: #AAF0FE;
                }

                span {
                    opacity: 0.76;
                    font-size: 12px;
                    color: #AAF0FE;
                }
            }
        }

        @media only screen and (max-width: 1500px) {
            .leftImgWrap {
                margin-right: 60px !important;
            }

            .productListBox {
                margin-right: 60px !important;
            }
        }
    }
</style>
